import classes from "./WidgetPair.module.css";

const WidgetPair = ({ className = "", children }) => {

    return (
        <div className={`${classes.WidgetPair} ${className}`}>
            {children}
        </div>
    );
};

export default WidgetPair;
